<mat-drawer-container>
  <mat-drawer #drawer mode="side" opened>
    <app-sidebar [toggleSidebar]="toggleSidebar.bind(this)"></app-sidebar>
  </mat-drawer>

  <mat-drawer-content [ngClass]="isExpanded ? 'drawer-content' : 'drawer-content-collapsed'">
    <mat-icon class="hambuerguer-icon" (click)="drawer.toggle(); toggleSidebar()">menu</mat-icon>
    <router-outlet></router-outlet>
  </mat-drawer-content>
</mat-drawer-container>